import { PatientActions, selectedPatient, patientAction, facilityStayAction } from './constant';

const {
  GET_PATIENT_REQUEST,
  GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST,
  REQUEST_VALIDATE_CSV_TEMPLATE,
  REQUEST_UPLOAD_CSV_TEMPLATE,
  RESET_UPLOAD_CSV_TEMPLATE,
  GET_RECENT_UPLOADED_HISTORY_REQUEST,
  GET_PATIENT_EXPORT_TEMPLATE_REQUEST,
  GET_PATIENT_EXPORT_TEMPLATE_RESET,
  RESET_VALIDATE_CSV_TEMPLATE,
  GET_ALL_PATIENT_REQUEST,
  GET_THERAPIST_DISCIPLINE_REQUEST,
  PUT_TREATMENT_THERAPIST_REQUEST,
  GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST,
  GET_ALL_PATIENT_LIST_REQUEST,
  GET_ALL_PATIENT_LIST_RESET,
  PERSISTS_BACK_PATIENT_CRITERIA,
  PERSISTS_BACK_PATIENT,
  PERSIST_PATIENT_STATUS_FILTER,
  PERSIST_PATIENT_ACTIVE_CERT,
} = patientAction;
const { GET_PATIENTS_REQUEST, GET_PATIENTS_RESET } = facilityStayAction;
const {
  GET_SINGLE_PATIENT_REQUEST,
  REQUEST_CREATE_PATIENT,
  RESET_CREATE_PATIENT,
  REQUEST_EDIT_PATIENT,
  RESET_EDIT_PATIENT,
  REQUEST_DEACTIVATE_PATIENT,
  RESET_DEACTIVATE_PATIENT,
  REQUEST_PATIENT_ID,
  GET_REQUEST_ENTERPRISE_PHYSICIAN,
  GET_PAYER_PLAN_TYPE_REQUEST,
  REQUEST_PATIENT_IN_ACTIVE_COUNT,
  SWITCH_THERAPIST_DISCIPLINE,
  GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST,
  GET_ALL_PATIENT_PRIOR_CHARGES_RESET,
} = PatientActions;

const { SELECT_PATIENT_FOR_THERAPY, SELECT_PATIENT_LIST_FOR_THERAPY, RESET_PATIENT_FOR_THERAPY } =
  selectedPatient;

export const selectPatient = (payload: object) => {
  return {
    type: SELECT_PATIENT_FOR_THERAPY,
    payload,
  };
};

export const resetSelectPatient = () => {
  return {
    type: RESET_PATIENT_FOR_THERAPY,
  };
};

export const selectPatientListAction = (payload: object) => {
  return {
    type: SELECT_PATIENT_LIST_FOR_THERAPY,
    payload,
  };
};

export const getSinglePatient = (payload: object) => {
  return {
    type: GET_SINGLE_PATIENT_REQUEST,
    payload,
  };
};

export const GET_PATIENT_RECORD = (payload: object) => {
  return {
    type: GET_PATIENT_REQUEST,
    payload,
  };
};

export const getAllPatientsListAction = (payload: any) => {
  return {
    type: GET_ALL_PATIENT_LIST_REQUEST,
    payload,
  };
};

export const getAllPatientsListResetAction = () => {
  return {
    type: GET_ALL_PATIENT_LIST_RESET,
  };
};

export const persistPatientIdAction = (payload: any) => {
  return {
    type: PERSISTS_BACK_PATIENT,
    payload,
  };
};

export const persistPatientListCriteria = (payload: any) => {
  return {
    type: PERSISTS_BACK_PATIENT_CRITERIA,
    payload,
  };
};

export const persistPatientStatusFilter = (payload: { active: boolean; inactive: boolean }) => {
  return {
    type: PERSIST_PATIENT_STATUS_FILTER,
    payload,
  };
};

export const persistPatientActiveCert = (payload: { PT: boolean; OT: boolean; SLP: boolean }) => {
  return {
    type: PERSIST_PATIENT_ACTIVE_CERT,
    payload,
  };
};

PERSISTS_BACK_PATIENT_CRITERIA;

export const getPatientActiveInActiveCount = (payload: object) => {
  return {
    type: REQUEST_PATIENT_IN_ACTIVE_COUNT,
    payload,
  };
};

export const getAllPhysicians = (payload: object) => {
  return {
    type: GET_REQUEST_ENTERPRISE_PHYSICIAN,
    payload,
  };
};

export const getAllTherapistAction = () => {
  return {
    type: GET_THERAPIST_DISCIPLINE_REQUEST,
  };
};

export const getSingleTherapistAction = (payload:object) => {
  return {
    type: GET_THERAPIST_SINGLE_DISCIPLINE_REQUEST,
    payload,
  };
};
export const updateTreatmentTherapistAction = (payload:object) => {
  return {
    type: PUT_TREATMENT_THERAPIST_REQUEST,
    payload,
  };
};




export const createPatientAction = (payload: object) => {
  return {
    type: REQUEST_CREATE_PATIENT,
    payload,
  };
};
export const resetCreatePatientAction = () => {
  return {
    type: RESET_CREATE_PATIENT,
  };
};

export const editPatientAction = (payload: object) => {
  return {
    type: REQUEST_EDIT_PATIENT,
    payload,
  };
};

export const deactivatePatientAction = (payload: object) => {
  return {
    type: REQUEST_DEACTIVATE_PATIENT,
    payload,
  };
};

export const resetDeactivatePatientAction = () => {
  return {
    type: RESET_DEACTIVATE_PATIENT,
  };
};

export const resetEditPatientAction = () => {
  return {
    type: RESET_EDIT_PATIENT,
  };
};

export const getPatientIdAction = (payload: object) => {
  return {
    type: REQUEST_PATIENT_ID,
    payload,
  };
};

export const getEnterprisePayerPlanType = () => {
  return {
    type: GET_PAYER_PLAN_TYPE_REQUEST,
  };
};

export const switchTherapistDisciplineAction = (payload: string | true | string[] | null) => {
  return {
    type: SWITCH_THERAPIST_DISCIPLINE,
    payload,
  };
};

export const getDownloadCSVPatientTemplate = () => {
  return {
    type: GET_DOWNLOAD_CSV_PATIENT_TEMPLATE_REQUEST,
  };
};

export const getValidationCSVTemplate = (payload: any) => {
  return {
    type: REQUEST_VALIDATE_CSV_TEMPLATE,
    payload,
  };
};

export const resetValidationCSVTemplate = () => {
  return {
    type: RESET_VALIDATE_CSV_TEMPLATE,
  };
};

export const getUploadCSVTemplate = (payload: any) => {
  return {
    type: REQUEST_UPLOAD_CSV_TEMPLATE,
    payload,
  };
};

export const resetUploadCSVTemplate = () => {
  return {
    type: RESET_UPLOAD_CSV_TEMPLATE,
  };
};

export const getRecentUploadHistoryPatients = () => {
  return {
    type: GET_RECENT_UPLOADED_HISTORY_REQUEST,
  };
};

export const getExportPatientTemplate = (payload: any) => {
  return {
    type: GET_PATIENT_EXPORT_TEMPLATE_REQUEST,
    payload,
  };
};

export const resetExportPatientTemplate = () => {
  return {
    type: GET_PATIENT_EXPORT_TEMPLATE_RESET,
  };
};

export const getAllPatientAction = () => {
  return {
    type: GET_ALL_PATIENT_REQUEST,
  };
};

export const getAllPatientsByAction = (payload: any) => {
  return {
    type: GET_PATIENTS_REQUEST,
    payload,
  };
};

export const resetPatientRecordAction = () => {
  return {
    type: GET_PATIENTS_RESET,
  };
};

export const getAllPatientPriorChargesAction = (patientUuid: string) => {
  return {
    type: GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST,
    patientUuid,
  };
};

export const resetGetAllPatientPriorChargesAction = () => {
  return {
    type: GET_ALL_PATIENT_PRIOR_CHARGES_RESET,
  };
};